var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","flex-direction":"column"}},[_vm._m(0),_c('div',[_c('button',{on:{"click":_vm.uploadFiles}},[_vm._v("Upload files")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"4rem"}},[_c('input',{attrs:{"multiple":"","type":"file"}})])
}]

export { render, staticRenderFns }